export function percentage(value: number): string {
  return new Intl.NumberFormat('it-IT', {
    style: 'percent',
    maximumFractionDigits: 1,
  }).format(value)
}

export function number(value: number): string {
  return new Intl.NumberFormat('it-IT').format(value)
}

export function compactNumber(value: number): string {
  return new Intl.NumberFormat('it-IT', {
    notation: 'compact',
    maximumFractionDigits: 1,
  }).format(value)
}

export function dateTime(value: string): string {
  return new Intl.DateTimeFormat('it-IT', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value))
}

export function duration(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}m ${seconds.toString().padStart(2, '0')}s`
}

export function mode(value: string): string {
  const labels: Record<string, string> = {
    casual_1v1: 'Casuale 1v1',
    ranked_1v1: 'Classificata 1v1',
    tournament: 'Torneo',
  }
  return labels[value] ?? value
}

export function mapName(value: string): string {
  const normalized = value.trim()
  if (normalized.length === 0) return '—'
  return `${normalized.charAt(0).toLocaleUpperCase('it-IT')}${normalized.slice(1)}`
}
